/// EmailTagInput の入力分割 (純関数) と共有型。コンポーネントから分離して
/// テスト可能にする。

/** 追加できなかった値とその理由 (表示用)。親が backend の結果から組み立てる。 */
export interface EmailTagAddFailure {
  value: string;
  reason: string;
}

/// タグ入力の確定・貼り付け値をメール候補に分割する。
/// カンマ (半角/全角)・読点・セミコロン・改行を区切りとして扱い、
/// trim 後に空の要素は落とす (値ごとの検証は分割後に行う)。
export function splitEmailInput(rawInput: string): string[] {
  return rawInput
    .split(/[,，、;\n\r]+/)
    .map((value) => value.trim())
    .filter((value) => value.length > 0);
}
